<template>
  <img class="card-icon" src="@/app/assets/images/card-brand/Interpayment.png" alt="Inter payment" />
</template>
<script>
export default {
  name: 'InterpaymentIcon',
}
</script>
<style lang="scss">
.card-icon {
  width: 20px;
  height: 20px;
}
</style>